export default __webpack_public_path__ + "static/media/autoprefixer.0c0793fd.svg";